/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Plan_Trial_PeriodInputs */

const en_plan_trial_period = /** @type {(inputs: Plan_Trial_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.period} trial`)
};

const es_plan_trial_period = /** @type {(inputs: Plan_Trial_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prueba de ${i?.period}`)
};

/**
* | output |
* | --- |
* | "{period} trial" |
*
* @param {Plan_Trial_PeriodInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_trial_period = /** @type {((inputs: Plan_Trial_PeriodInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Trial_PeriodInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_trial_period(inputs)
	return en_plan_trial_period(inputs)
});